import ButtonGrid from './button-grid.component'

export default ButtonGrid